import { render, staticRenderFns } from "./erp.vue?vue&type=template&id=0ac67da1&scoped=true&"
import script from "./erp.vue?vue&type=script&lang=js&"
export * from "./erp.vue?vue&type=script&lang=js&"
import style0 from "./erp.vue?vue&type=style&index=0&id=0ac67da1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ac67da1",
  null
  
)

export default component.exports